import script from "./AboutPixStar.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutPixStar.vue?vue&type=script&setup=true&lang=js"

import "./AboutPixStar.vue?vue&type=style&index=0&id=32084acb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32084acb"]])

export default __exports__